import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ComboReuniao } from 'src/app/core/combo-reuniao';
import { ReuniaoService } from 'src/app/services/reuniao/reuniao.service';


@Component({
  selector: 'combo-reuniao',
  templateUrl: './combo-reuniao.component.html',
  styleUrls: ['./combo-reuniao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboReuniaoComponent implements OnInit {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label;
  @Input() campoPesquisavel = 'descricao'; 
  @Input() fxFlexOffset = "20px";

  @Output() valorChange = new EventEmitter();
  
  dados = [];
  data: any = {};

  area: string;
  menu: string;
  constructor(private reuniaoService: ReuniaoService, private router: Router,
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.data = Date.now();
    this.area = this.getArea();    
    setTimeout(() => {
      let $_evento;
      
      $_evento = this.reuniaoService.getAllIntituicaoLogada(this.area);  

      $_evento.subscribe((reunioes: ComboReuniao[]) => {
        this.dados = reunioes;
        this.preencherCombo();

        this.dados.forEach(a => {
          a.descricao = a.descricao;
          a.descricaoLocalExecucao = a.descricaoLocalExecucao;
        } );

        
        this.dados.sort((a, b) => {
          if (a.descricao > b.descricao) { return 1; }
          if (a.descricaoLocalExecucao < b.descricaoLocalExecucao) { return -1; }
          return 0;
        });
      });

    }, 0);

  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
      this.preencherCombo();
    }
  }

  private preencherCombo() {
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }
}
